import React, {Component} from 'react';
import PaginationBuilder from './../common/PaginationBuilder';
import AppCatalogTable from './AppCatalogTable';
import {getAppCatalog} from './GetAppCatalog';

class AppCatalog extends Component {

	constructor(props) {
		super(props);
		this.state = {
				snapshotItemsPerPage:3,
				pageRangeDisplayed:5
		};
		this.paginator = React.createRef();
	}

	componentDidMount() {
			const {catalog, updateAppCatalog} = this.props;
			
			if(catalog.length === 0){
				getAppCatalog(updateAppCatalog);
			}
	}

	render() {
		const {catalog, pageItems, isPaginationRequired, itemsPerPage} = this.props;
		if(isPaginationRequired === true){
			return [
				<AppCatalogTable 
					key="appCatalogTable" 
					applications={pageItems}
				/>,       
				<PaginationBuilder 
					key="paginationBuilder" 
					ref={this.paginator} 
					items={catalog}
					totalItems={catalog.length}
				    serverSidePagination="false"
					refreshPage={this.refreshPage}
					itemsPerPage={itemsPerPage}  
					pageRangeDisplayed={this.state.pageRangeDisplayed}
					href="#/myApps"
				/>
			];
		} else if(isPaginationRequired === false && catalog.length > 0) {
			return <AppCatalogTable 
								key="appCatalogTable" 
								applications={catalog.slice(catalog, this.state.snapshotItemsPerPage)} 
						 />;
		} else {
			return null;
		}
	}

	refreshPage = (pageNumber, pageItems) => {
		this.props.updatePageInfo(pageNumber, pageItems);
	}
}

export default AppCatalog;


// WEBPACK FOOTER //
// ./src/manageMyAccount/AppCatalog.js